import { FC, useMemo } from 'react'
import { ResourceHistoryPanelItemProps } from './ResourceHistoryPanelItem.model'
import { getFullName } from '../../../../misc/user.utilities'
import { formatFr } from '../../../../misc/date.utilities'
import { InsEventTypeEnums } from '../../../../features/ins/enums/insEventType.enums'
import { ResourceItem } from '@follow-health/fw_ui_library/dist/features/app/features/Patients/ResourceHistory/components/ResourceItem'
import {
  ResourceHistoryExtraData,
  ResourceHistoryMssExtraData,
} from '../../../../model/ResourceHistory'
import InsUtilities from '../../../../features/ins/utilities/Ins.utilities'

export const ResourceHistoryPanelItem: FC<ResourceHistoryPanelItemProps> = ({ historyDetail }) => {
  const { changes, date, user } = historyDetail
  const formatedDate = formatFr(date, 'dd/MM/yyyy HH:mm')
  const fullNameWithoutTitle = (user ? `${getFullName(user)}` : null) ?? 'Importé par Follow'

  const titleGenerated = useMemo(() => {
    switch (historyDetail.eventType) {
      case 'create':
        return 'Création'
      case 'mss_insi_flux':
        return "Réception d'un flux MSS"
      case 'mss_email_sent':
        return "Envoi d'email MSS"
      case 'mss_cda_modified':
      case 'mss_cda_deleted':
        return "Compte rendu d'examens biologiques"
      case InsEventTypeEnums.INS_ACCESS:
        return 'Consultation INS'
      case InsEventTypeEnums.INS_CHECK:
        return 'Vérification INS'
      default:
        return 'Modification'
    }
  }, [historyDetail.eventType])

  const resourceHistoryContent = useMemo(() => {
    if (
      historyDetail.eventType === InsEventTypeEnums.INS_ACCESS &&
      historyDetail.resourceType === 'Patient'
    ) {
      return (
        <ResourceItem
          title={titleGenerated}
          dateItem={formatedDate}
          authority={fullNameWithoutTitle}
          patientId={`ID patient: ${historyDetail.resourceId}`}
          type={'ins_access'}
        />
      )
    } else if (
      historyDetail.eventType === InsEventTypeEnums.INS_CHECK &&
      historyDetail.resourceType === 'Patient'
    ) {
      return (
        <>
          <ResourceItem
            title={titleGenerated}
            dateItem={formatedDate}
            authority={fullNameWithoutTitle}
            patientId={`ID patient: ${historyDetail.resourceId}`}
            type={'ins_check'}
          >
            <div className={'flex flex-col gap-1 text-shades-4 '}>
              <div>
                {historyDetail?.extraData?.['insCheckType'] !== null && (
                  <>
                    <span>{`Type: ${historyDetail?.extraData?.['insCheckType']}`}</span>
                  </>
                )}
                {historyDetail?.extraData?.['insChecked'] !== null && (
                  <>
                    <span> - </span>
                    <span>{`Status: ${historyDetail?.extraData?.['insChecked'] === 'ins_check_ko' ? 'Echec' : InsUtilities.getIdentityStatusLabel(historyDetail?.extraData?.['insChecked'])}`}</span>
                  </>
                )}
              </div>
              {historyDetail?.extraData?.['insChecked'] !== null &&
                historyDetail?.extraData?.['insChecked'] !== 'ins_check_ko' &&
                (historyDetail?.extraData?.['birthLastName'] ||
                  historyDetail?.extraData?.['errorMessage']) && (
                  <div>
                    <span>Retour INS : </span>
                    <>
                      {historyDetail?.extraData?.['errorMessage'] &&
                        historyDetail?.extraData?.['errorMessage'] !== null && (
                          <span>{`Message d'erreur : ${historyDetail?.extraData?.['errorMessage']}`}</span>
                        )}
                      {historyDetail?.extraData?.['birthLastName'] &&
                        historyDetail?.extraData?.['birthLastName'] !== null && (
                          <span>{`Nom de naissance : ${historyDetail?.extraData?.['birthLastName']}`}</span>
                        )}
                      {historyDetail?.extraData?.['birthFirstName'] &&
                        historyDetail?.extraData?.['birthFirstName'] !== null && (
                          <>
                            <span> - </span>
                            <span>{`Prénom de naissance : ${historyDetail?.extraData?.['birthFirstName']}`}</span>
                          </>
                        )}
                      {historyDetail?.extraData?.['otherFirstNames'] &&
                        historyDetail?.extraData?.['otherFirstNames'] !== null && (
                          <>
                            <span> - </span>
                            <span>{`Autres Prénoms : ${historyDetail?.extraData?.['otherFirstNames']}`}</span>
                          </>
                        )}
                      {historyDetail?.extraData?.['sex'] &&
                        historyDetail?.extraData?.['sex'] !== null && (
                          <>
                            <span> - </span>
                            <span>{`Genre : ${historyDetail?.extraData?.['sex']}`}</span>
                          </>
                        )}
                      {historyDetail?.extraData?.['inseeNumber'] &&
                        historyDetail?.extraData?.['inseeNumber'] !== null && (
                          <>
                            <span> - </span>
                            <span>{`Matricule INS: ${historyDetail?.extraData?.['inseeNumber']}`}</span>
                          </>
                        )}
                      {historyDetail?.extraData?.['assigningAuthority'] &&
                        historyDetail?.extraData?.['assigningAuthority'] !== null && (
                          <>
                            <span> - </span>
                            <span>{`OID : ${historyDetail?.extraData?.['assigningAuthority']}`}</span>
                          </>
                        )}
                    </>
                  </div>
                )}
            </div>
          </ResourceItem>
        </>
      )
    } else if (
      historyDetail.eventType === 'mss_insi_flux' &&
      historyDetail.resourceType === 'Patient'
    ) {
      const extraData = historyDetail.extraData as ResourceHistoryExtraData
      return (
        <ResourceItem title={titleGenerated} type={'mss_insi_flux'} dateItem={formatedDate}>
          <>
            <div className="flex flex-row space-x-1 flex-grow mr-2 text-shades-4 ">
              <span>{`Émetteur: ${historyDetail.extraData.sender}`}</span>
              <span>-</span>
              <span>{`Destinataire: ${extraData.recipient}`}</span>
              <span>-</span>
              <span>{`Date réception: ${formatedDate}`}</span>
              <span>-</span>
              <span>{`Patient: ${extraData.birthFirstName} ${extraData.birthLastName}`}</span>
              <span>-</span>
              <span>{`Matricule INS: ${extraData.inseeNumber}`}</span>
            </div>
          </>
        </ResourceItem>
      )
    } else if (
      historyDetail.eventType === 'mss_email_sent' &&
      historyDetail.resourceType === 'Patient'
    ) {
      const extraData = historyDetail.extraData as ResourceHistoryMssExtraData
      const sentDoc = extraData.documents?.filter((document)=>document?.title);
      return (
        <ResourceItem title={titleGenerated} type={'mss_insi_flux'} dateItem={formatedDate}>
          <>
            <div className="flex flex-col   flex-grow mr-2 text-shades-4 ">
              <span>{`- Date d'émission : ${formatedDate}`}</span>
              <span>{`- Émetteur : ${historyDetail.extraData.sender}`}</span>
              <span>
                {`- Destinataires : ${extraData.recipients?.map((reciptient) => `${reciptient?.firstname} ${reciptient?.lastname} - ${reciptient?.email}`)?.join(', ')}`}
              </span>
              <span>
                <b>{`- Patient : ${extraData.birthFirstName} ${extraData.birthLastName}`}</b>
              </span>
              <span>{`- Matricule INS : ${extraData.inseeNumber}`}</span>
              {sentDoc?.length ? <span>
                {`- Documents envoyés : ${sentDoc?.map((document) => `${document?.title}`)?.join(', ')}`}
              </span>:undefined}
            </div>
          </>
        </ResourceItem>
      )
    } else if (
      (historyDetail.eventType === 'mss_cda_deleted' ||
        historyDetail.eventType === 'mss_cda_modified') &&
      historyDetail.resourceType === 'Patient'
    ) {
      const extraData = historyDetail.extraData as { title: string }
      return (
        <ResourceItem
          title={titleGenerated}
          patientId={`ID patient: ${historyDetail.resourceId}`}
          dateItem={formatedDate}
          authority={fullNameWithoutTitle}
          type={'ins_check'}
        >
          <>
            <div className={'flex flex-col gap-1 text-shades-4 '}>
              <div>
                <>
                  <span>{`Type: ${historyDetail.eventType === 'mss_cda_deleted' ? 'Suppression' : 'Modification'}`}</span>
                </>
              </div>
              {extraData?.title !== null && (
                <div>
                  <>
                    <span>{`Message: ${extraData?.title}`}</span>
                  </>
                </div>
              )}
            </div>
          </>
        </ResourceItem>
      )
    } else {
      return (
        <ResourceItem
          title={titleGenerated}
          dateItem={formatedDate}
          authority={fullNameWithoutTitle}
          patientId={`ID patient: ${historyDetail.resourceId}`}
          type={'create'}
        >
          <div className="text-shades-4 ">
            {changes.length > 0 && <span>{changes.join(', ')}</span>}
          </div>
        </ResourceItem>
      )
    }
  }, [changes, formatedDate, fullNameWithoutTitle, titleGenerated, historyDetail])

  return <>{resourceHistoryContent}</>
}
